<template>
  <div class="register-container">
    <div class="header-title" >注册新会员</div>
    <div class="form">
      <div class="form-item">
        <div class="title">+86</div>
        <div class="content">
          <input type="text" placeholder="绑定手机号"  maxlength="11" v-model="phone" />
          <div class="tips">必填</div>
        </div>
      </div>

      <div class="form-item">
        <div class="title">验证</div>
        <div class="content">
          <input type="text" placeholder="短信验证码" maxlength="6" v-model="captcha" />
          <div class="get-code" @click="getSms" :disabled="disabled">
            {{ text }}
          </div>
        </div>
      </div>

<!--      <div class="form-item">
        <div class="title">姓名</div>
        <div class="content">
          <input type="text" placeholder="" v-model="nickName" maxlength="12"/>
          <div class="tips">必填</div>
        </div>
      </div>-->

      <div class="form-item">
        <div class="title">分享</div>
        <div class="content">
          <input type="text" placeholder="分享人手机号" v-model="spread_phone"  maxlength="11" />
          <div class="tips">必填</div>
        </div>
      </div>

      <!--<div class="agree-xieyi">
        <div class="checkbox-wrapper">
          <label class="well-check">
            <input type="checkbox" v-model="xieyiOk" />
            <i class="icon"></i>
            已阅读并同意 <span class="xieyi">《用户协议》</span>
          </label>
        </div>
      </div>-->
    </div>
    <div class="register-action" :class="{'disabled':!canSubmit}" @click="registerAction">注册</div>
  </div>
</template>

<style lang="scss" scoped>
  .register-container {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: #fff;
    padding: 0.26rem 0.34rem;
    position: relative;
    overflow-y: scroll;
    .close {
      position: absolute;
      width: 0.4rem;
      height: 0.4rem;
      color: #888;
      line-height: 0.4rem;
      text-align: center;
      font-size: 0.46rem;
    }
    .header-title {
      padding: 0.5rem 0 0;
      color: #333;
      font-size: 0.64rem;
      transition: 0.5s;
    }
    .form {
      .form-item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #f0f0f0;
        padding: 0.24rem 0;
        margin-top: 0.28rem;
        &:first-of-type{
          margin-top:0;
        }
        .title {
          width: 1.8rem;
          color: #333;
          font-size: 0.36rem;
          text-align: left;
        }
        .content {
          flex: 1;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          margin-left: 0.1rem;
          .tips {
            width: 3em;
            font-size: 0.32rem;
            color: #ccc;
            margin-left: 0.2rem;
            text-align: right;
          }
          .get-code {
            flex: 1;
            color: #3d81ff;
            font-size: 0.24rem;
            text-align: right;
            min-width: 1.2rem;
          }
          input {
            flex: 1;
            font-size: 0.32rem;
          }
          input::-webkit-input-placeholder {
            color: #999;
          }
        }
      }
      .agree-xieyi {
        margin-top: 0.4rem;
        color: #999;
        font-size: 0.24rem;
        .checkbox-wrapper {
          padding-left: 0.32rem;
          .icon {
            width: 0.28rem;
            height: 0.28rem;
          }
          .xieyi {
            color: #fe5c48;
          }
        }
      }
    }
  }

  .register-action {
    font-size: 0.36rem;
    width: 7rem;
    height: 0.9rem;
    border-radius: 0.1rem;
    text-align: center;
    line-height: 0.9rem;
    color: #ffffff;
    margin-top: 2rem;
    background-color: #f44939;
  }
  .register-action.disabled{
    background-color: #ef9088;
  }

</style>
<script>
  import sendVerifyCode from "@mixins/SendVerifyCode";
  import { chs_phone, required } from "@utils/validate";
  import { validatorDefaultCatch } from "@utils/dialog";
  import { registerVerify, newRegister, getCodeApi } from "@api/user";
  import { getPhoneFromUid } from "@api/public"
  import dayjs from "dayjs";
  import cookie from "@utils/store/cookie";
  import debounce from "lodash.debounce";

  export default {
    name: "Register",
    data: function() {
      return {
        logoUrl: "",
        keyCode: "",
        phone: "",
        captcha: "",
        nickName:'',
        IDCard: "",
        cacheKey:this.$route.params.cacheKey,
        spread_phone: "",
        xieyiOk: 0,
        canSubmit:true,
      };
    },
    mixins: [sendVerifyCode],
    watch: {
      $route(n) {
        if (n.name === "Register") {
          this.cacheKey = this.$route.params.cacheKey;
        }
      }
    },
    mounted() {
      //校验注册cache_key参数
      this.getCode();
      // 获取手机号
      //this.getPhoneFromUid()
      console.log('推荐人id',cookie.get("spread"));
      console.log('跳转链接',cookie.get("login_back_url"));//BACK_URL
      console.log(this.$route.params.cacheKey);
      this.cacheKey = this.$route.params.cacheKey;
    },
    methods: {

      /**
       * uid获取用户手机
       */
      getPhoneFromUid(){
        let spread = cookie.get('spread')
        if (spread==null) return false
        getPhoneFromUid({uid:spread}).then(res=>{
          this.spread_phone = res.data.phone
        })
      },
      /**
       * 获取验证码密钥
       */
      getCode() {
        getCodeApi()
                .then(res => {
                  this.keyCode = res.data.key;
                })
                .catch(res => {
                  this.$dialog.error(res.msg);
                });
      },
      /**
       * 获取验证码
       * @returns {Promise<*>}
       */
      async getSms() {
        const { phone } = this;
        try {
          await this.$validator({
            phone: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message("手机号码"))
            ]
          }).validate({ phone });
        } catch (e) {
          return validatorDefaultCatch(e);
        }

        registerVerify({
          phone: this.phone,
          key: this.keyCode,

        })
                .then(res => {
                  // 执行倒计时
                  this.$dialog.success(res.msg);
                  this.sendCode();
                })
                .catch(res => {
                  this.$dialog.error(res.msg);
                  if (res.data.status === 402 || res.data.status === 401) {
                    this.getCode();
                  }
                });
      },
      /**
       * 新注册操作
       */
      async registerAction() {
        if (!this.canSubmit) {
          this.$dialog.toast({mes:'数据查询中，请稍后'})
          return false
        }
        this.canSubmit = false;
        let that = this;



        // 正常注册流程
        const { phone, spread_phone, captcha, nickName } = this;
        try {
          await this.$validator({
            phone: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message("手机号码"))
            ],
            captcha: [required(required.message("验证码"))],

          }).validate({ phone, captcha });//
        } catch (e) {
          this.canSubmit = true;
          return validatorDefaultCatch(e);
        }
        newRegister({
          phone: this.phone,
          captcha: this.captcha,
          //nick_name: this.nickName,
          //IDCard: this.IDCard,
          spread_phone: this.spread_phone,
          //ok: this.xieyiOk,
          cacheKey: this.cacheKey,
        })
                .then(res => {
                  let { data } = res;

                  this.$store.commit("LOGIN", data.token, dayjs(data.expires_time));
                  this.$store.commit("UPDATE_USERINFO", data.user_info);
                  this.$dialog.success("注册成功");

                  setTimeout(() => {
                    const backUrl = cookie.get("login_back_url") || "/";
                    //cookie.remove(BACK_URL);
                    this.$router.replace({ path: backUrl });
                  }, 2000);
                })
                .catch(err => {
                  this.$dialog.error(err.msg);
                  that.canSubmit = true;
                });
      }
    }
  };
</script>
